/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  check: 'check_be7e846f',
  owner: 'owner_be7e846f',
  isSelected: 'isSelected_be7e846f',
  isVisible: 'isVisible_be7e846f',
  isDisabled: 'isDisabled_be7e846f',
};

export = styles;

loadStyles([{"rawString":".check_be7e846f{display:inline-block;cursor:default;box-sizing:border-box;vertical-align:top;background:0 0;border:none;opacity:0}.check_be7e846f::-moz-focus-inner{border:0}.check_be7e846f{outline:transparent}.check_be7e846f{position:relative}.ms-Fabric.is-focusVisible .check_be7e846f:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid "},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":"}.check_be7e846f:focus{opacity:1}button.check_be7e846f{padding:6px}.owner_be7e846f.isSelected_be7e846f .check_be7e846f,.owner_be7e846f.isVisible_be7e846f .check_be7e846f,.owner_be7e846f:focus .check_be7e846f,.owner_be7e846f:hover .check_be7e846f{opacity:1}.isDisabled_be7e846f{visibility:hidden}"}]);
/* tslint:enable */